/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { defineStore } from 'pinia';

import {
  AutocompleteRepository,
  IssuerResponse,
} from '@/repositories/generated';

type IssuerAutocompleteStoreState = {
  issuers: IssuerResponse[];
};

export const useIssuerAutocompleteStore = defineStore('issuerAutocomplete', {
  state: (): IssuerAutocompleteStoreState => ({
    issuers: [],
  }),
  actions: {
    async getIssuers() {
      // 一度取得したらキャッシュから取得
      if (this.issuers.length) {
        return this.issuers;
      }

      const res = await AutocompleteRepository.searchIssuer({
        term: undefined,
      });
      this.issuers = res;
      return res;
    },
  },
});
